module.exports = __webpack_public_path__ + "i18n/zh-TW.16b84b3cbc5784d931fb2d0f0ffdca41.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-TW.json
// module id = 1006
// module chunks = 60